import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  class: "ion-padding-start",
  slot: "content"
}
const _hoisted_3 = { slot: "content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ion_accordion_group, { multiple: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_reorder_group, {
          onIonItemReorder: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doReorderDiscipline($event, _ctx.selectedDisciplines))),
          disabled: _ctx.readOnly ? true : false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDisciplines, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                value: item.id
              }, [
                _createVNode(_component_ion_accordion, {
                  value: item.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_reorder, {
                          slot: "start",
                          style: {"margin-inline-end":"8px"}
                        }),
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, [
                              _createElementVNode("b", null, _toDisplayString(idx+1) + ". " + _toDisplayString(item.name), 1),
                              _cache[2] || (_cache[2] = _createTextVNode()),
                              _createElementVNode("small", null, "(" + _toDisplayString(item.nameChi) + ")", 1)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        (!_ctx.readOnly)
                          ? (_openBlock(), _createBlock(_component_ion_buttons, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  color: "danger",
                                  onClick: _withModifiers(($event: any) => (_ctx.onDeleteChosenDiscipline(idx, item)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      size: "small",
                                      slot: "start",
                                      icon: _ctx.trashOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_ion_item, {
                        lines: "full",
                        style: {"--min-height":"16px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap ion-no-margin" }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createElementVNode("p", { style: {"margin":"0","line-height":"1"} }, [
                                _createElementVNode("small", null, "Related to this discipline")
                              ], -1)
                            ])),
                            _: 1,
                            __: [3]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_accordion_group, { multiple: true }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDisciplineRelatedPrograms(item, true), (programs, uniName) => {
                            return (_openBlock(), _createBlock(_component_ion_accordion, {
                              style: {"--min-height":"24px"},
                              key: uniName
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  slot: "header"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", null, [
                                          _createElementVNode("b", null, _toDisplayString(uniName), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (_ctx.getNumSelectedPrograms(programs) > 0)
                                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                                          key: 0,
                                          color: "primary"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getNumSelectedPrograms(programs)) + " selected", 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("div", _hoisted_3, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(programs, (p) => {
                                    return (_openBlock(), _createBlock(_component_ion_item, {
                                      lines: "full",
                                      key: p.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_checkbox, {
                                          "aria-label": p.displayName,
                                          style: {"margin-inline-end":"12px"},
                                          slot: "start",
                                          onIonChange: ($event: any) => (_ctx.onCheckProgram(p)),
                                          checked: _ctx.getProgramIdxInList(p) >= 0,
                                          disabled: _ctx.readOnly
                                        }, null, 8, ["aria-label", "onIonChange", "checked", "disabled"]),
                                        _createVNode(_component_ion_label, {
                                          class: "ion-text-wrap",
                                          style: {"margin":"4px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("p", {
                                              style: _normalizeStyle([{"line-height":"1.2","font-size":"90%"}, { 'font-weight': _ctx.getProgramIdxInList(p) >= 0 ? 'bold': 400 }])
                                            }, [
                                              (p.jupasUrl)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                                    _cache[4] || (_cache[4] = _createTextVNode("[")),
                                                    _createElementVNode("a", {
                                                      href: p.jupasUrl,
                                                      target: "_blank"
                                                    }, _toDisplayString(p.jupasCode), 9, _hoisted_5),
                                                    _createTextVNode("] " + _toDisplayString(p.label), 1)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(p.displayName), 1))
                                            ], 4)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1032, ["value"])
              ], 8, _hoisted_1))
            }), 128))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "ion-margin-top ion-justify-content-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_button, {
          color: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openABDisciplineSelectModal()))
        }, {
          default: _withCtx(() => [
            (_ctx.readOnly)
              ? (_openBlock(), _createBlock(_component_ion_icon, {
                  key: 0,
                  slot: "end",
                  icon: _ctx.arrowForward
                }, null, 8, ["icon"]))
              : (_openBlock(), _createBlock(_component_ion_icon, {
                  key: 1,
                  slot: "start",
                  icon: _ctx.add
                }, null, 8, ["icon"])),
            _cache[5] || (_cache[5] = _createTextVNode(" Disciplines "))
          ]),
          _: 1,
          __: [5]
        })
      ]),
      _: 1
    })
  ]))
}